package com.essntl.features.travelagent.data.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.features.travelagent.data")
class TravelAgentModule
